// eslint-disable-next-line
Number.prototype.fcmRound = function(precision=2) {
  if(!this) {
    return 0;
  }
  if(!precision) {
    precision = 2;
  }
  const factor = Math.pow(10, precision);
  return (Math.round(this * factor)/factor) ||0;
};
// eslint-disable-next-line
Number.prototype.fcmCurrency = function() {
  if(!this) {
    return 0;
  }
  const factor = Math.pow(10, 2);
  return (Math.round(this * factor)/factor) ||0;
};
